module.exports = __webpack_public_path__ + "static/media/DevTest.b2d59390.png";